<template>
    <div class="newcontent">
        <div class="nw-content">
            <div>
            <h3> {{$t('Welcome to TwinkleTalk')}} </h3>
            <span> {{$t('Please tell us a little about yourself')}} </span>
            </div>
         <div>
            <div>
                    <el-form :model="ruleForm"  :rules="rules" ref="ruleForm"  :hide-required-asterisk="true" label-position="top"  >
                        <el-form-item :label="$t('Phone Number')" prop="mobile_code">
                            <el-input  disabled v-model="ruleForm.mobile_code"  ></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Kid(s) Nickname')" prop="nickname">
                            <el-input  v-model="ruleForm.nickname"  :placeholder="$t('Kid(s) Nickname')" ></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Email address')" prop="email">
                            <el-input v-model="ruleForm.email"  placeholder="example@email.com"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Wechat ID')" prop="wechat_id">
                            <el-input v-model="ruleForm.wechat_id"  placeholder="wechat ID"></el-input>
                        </el-form-item>
                        <el-form-item class="form-botton">
                            <el-button class="wp-button" type="primary" @click="submitForm('ruleForm')"> {{$t('Submit')}} </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
      <div class="interbox" v-if="btnFlag"  @click="handleLogin" > {{$t('Claim FREE Package')}} </div>
        <div v-show="dialogVisible" class="show-captcha"  @click="closebg">
        <div  class="show-captcha-div" @click.stop>
                <div ref="captcha"></div>
                <!-- <button ref="popups" class=" captcha-botton"> {{$t('Click Refresh Verification Code')}}</button>                     -->
        </div>
        </div>
    </div>
</template>
<script>
import { setStore, getStore, keys } from '@/store';
  export default {
    data() {
      return {
        ruleForm: {
            nickname: '',
            email: '',
            mobile: '',
            country_code:'',
            wechat_id:'',
            mobile_code:''

        },
        rules: {
           email: [
            {
                required: true,
                message: this.$i18n.t("Please enter your email"),
                trigger: "blur"
            },
            {
                type: "email",
                message: this.$i18n.t("Please enter the correct email address"),
                trigger: ["blur", "change"]
            }
         ],
        },
        invite_code:'',
       dialogVisible: false,
            input:'',
            screenWidth:'',
            messagecode:false
      };
    },
    mounted(){
        var that=this
        that.screenWidth  =document.body.clientWidth ||window.screenWidth;
        window.addEventListener("resize", function() {
                        return(() => {
                         that.screenWidth  =document.body.clientWidth ||window.screenWidth;
                            //  console.log(that.screenWidth)
                        })();
                    });
        this.ruleForm.country_code=this.$route.params.country_code
        this.ruleForm.mobile=this.$route.params.phone
        if(this.ruleForm.country_code!=null&&this.ruleForm.mobile!=null){
            this.ruleForm.mobile_code='+'+this.ruleForm.country_code +' '+this.ruleForm.mobile
        }else{
            this.$router.push({ path: '/' });
        }
        //生成验证
        var self = this;
		    var options = {
		      element: this.$refs.captcha,
		      captchaId: "2e3422055bf14588a401899f1d8b25b6",
		      width: "320px",
              mode: 'embed',
              apiVersion: 2,
               lang :this.$i18n.locale=='en'?'en':'zh-CN',
              onVerify:(err,data)=>{   //验证之后的回调函数,err验证失败才有值
                   if (err){
                    this.input=''
                    return
                  }
                  if(data){
                      this.input=data.validate
                      this.dialogVisible=false
                      this.submitForm('ruleForm')
                      self.instance && self.instance.refresh();
                    //    console.log(data.validate)
                  }
              }
		    };
		    initNECaptcha(options, function onLoad(instance) { //初始化成功
		    //   console.log(instance);
		      self.instance = instance;
		    },
            function onerror (err) { //初始化失败
                console.log(err)
            }
            );
		    this.$refs.popups.addEventListener("click", function() {
		      self.instance && self.instance.refresh();
		    });
    },
    methods: {
        //关闭弹窗
        closebg(){
            this.dialogVisible=false
            },
         submitForm(ruleForm) {
                    this.$refs[ruleForm].validate( (valid) => {
                        if (valid) {
                            if(this.input==''){
                            this.dialogVisible=true
                            return
                        }else{
                             this.$http.post('/api/signUpUser', {
                                'mobile': this.ruleForm.mobile,
                                'country_code': this.ruleForm.country_code,
                                // 'invite_code': this.$route.query.invite_codem,
                                'child_nickname':this.ruleForm.nickname,
                                'email':this.ruleForm.email,
                                'wechat_id':this.ruleForm.wechat_id,
                                'landingpage_id':13,
                                utm_source:'pc',
                                utm_medium:'register',
                                'captcha':this.input,
                                ...this.$route.query,
                                }).then((res) => {
                                    this.input=''
                                if (res.data.code == 200) {
                                    this.toLog(res.data.data.user_sn)
                                    setStore(keys.userInfo, res.data.data);
                                    let userinvite=res.data.data
                                    this.$router.push({ path: '/nuinfo' ,query:{invite_code:userinvite.invite_code}})
                                    // setTimeout(() => {
                                    // // window.location.href = res.data.data.url
                                    // this.$router.push({ path: '/nuinfo' ,query:{invite_code:userinvite.invite_code}})
                                    // }, 1000);
                                } else {
                                    this.$message({
                                    message: res.data.msg,
                                    type: 'warning'
                                    })
                                }
                                })
                                }
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });

        },
        toLog (user_sn) {
      this.$http.post('/api/addCheckPointsLog',
       { type:1, user_sn:user_sn, value:'landingpage-id:13' }).then((res) => {
      })
    }
    }
  }
</script>
<style lang="less" scoped>
//弹窗样式
.captcha-botton{
  width: 90%;
  height: 40px;
   border-radius:6px;
   cursor: pointer;
       background-color: #409eff;
    border-color: #409eff;
    color: #fff;
    border: none;
}
//图片滑动验证码样式
.show-captcha{
   position: fixed;
   display: flex;
   justify-content:center;
   align-items:center;
   top: 0%;
   left: 0%;
   right: 0;
   bottom: 0;
   background-color: rgba(0, 0, 0, 0.3);
   z-index: 99999999999;
   .show-captcha-div{
       display: flex;
       justify-content : center;
       align-items:center;
       flex-direction:column;
       width: 350px;
       height: 350px;
       background: #fff;
       padding: 5px 5px;
       position: relative;
       div{
         text-align: center;
         box-sizing: border-box;
       }
       button{
          //  position: absolute;
          //  bottom: 10px;
           width: 80%;
           margin-top: 20px;
          //  left: 10%;
       }

   }
}
.newcontent{
    background: #F5F5F5;
    height: 100vh;
}
/deep/.el-button--primary{
    border: 1px solid #DCDFE6;
}
.wp-button {
  width: 100%;
  height: 50px;
  border-radius: 100px;

  &.primary {
    background: #4b69fe;
    color: white;
  }
}
.nw-content{
    width: 600px;
    margin: auto;
    display: flex;
    flex-direction:column;
    justify-content:center;
    height: 100vh;
    div{
        h3{
            font-family: ' Sofia Pro Bold';
            font-style: normal;
            font-weight: 700;
            font-size: 28px;
            line-height: 36px;
            color: #111827;
            text-align: center;
            margin: 0;
        }
        span{
            display: block;
            font-family: 'Sofia Pro';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 28px;
            color: #6B7280;
            text-align: center;
            margin: 8px auto 0;
        }
    }
    /deep/.el-input__inner{
        border: 1px solid #D1D5DB;
    }
    /deep/.el-form{
        margin: 20px auto 0;
        padding: 0 20px;
        .el-form-item{
            margin-bottom: 15px;
            .el-input__inner{
                font-family: 'Sofia Pro';
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #9CA3AF;

                box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
                border-radius: 6px;
            }
        }
        .form-botton{
                margin-top: 40px;
                .el-button--primary{
                    background: #4B4EFC;
                    border-radius: 43px;
                    span{
                        font-family:  Sofia Pro SemiBold;
                        font-style: normal;
                        font-weight: 500;
                        font-size: 18px;
                        color: #FFFFFF;
                    }
                }
            }
        .el-form-item__label{
            padding: 0;
            margin-bottom: 4px;
            font-family:  Sofia Pro SemiBold;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #111827;
        }
    }

}
@media screen and (max-width: 763px) {
    //验证码插件弹图位置
    /deep/ .yidun_intellisense--light .yidun_classic-container{
       bottom: 0;
       top: auto;
    }
   /deep/ .yidun_popup.yidun_popup--light .yidun_modal{
       bottom: 0;
       top: auto;
       left: 0;
       width: 100%;
       position: absolute;
    }
//--------------------------------------------
    .newcontent{
    background: #F5F5F5;
    height: 100%;
    overflow: hidden;
}
    .nw-content{
    width: 100%;
    margin: 37px auto 0;
     /deep/.el-form{
         margin: 52px auto 0;
         .form-botton{
                margin: 52px auto 57px;
        }
     }
    }
}
  /deep/.wp-input .el-input-group__prepend:focus-within{
    border:1px solid hsl(0, 0%, 0%);
  }
   /deep/.el-input__inner:focus{
 border:1px solid hsl(0, 0%, 0%);
  }
  /deep/.nw-content .el-form .el-form-item .is-disabled .el-input__inner{
      background: #E8E8E8;
  }
</style>



// WEBPACK FOOTER //
// src/components/newUser.vue